import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

const Wire: React.FC = () => {
    return (
        <div className="withdraw-wire-root">
            <Outlet context={{ currency: 'USD' }} />
        </div>
    );
};

export function useCurrency() {
    return useOutletContext<{ currency: 'USD' }>().currency;
}

export default Wire;
